import * as types from '../actions/actionTypes';
import initialState from './initialState';

export function merchZone(state = initialState.merchZone, action) {
    switch (action.type) {
        case types.MERCHZONE_SUCCESS:
            return action.response;
        default:
            return state;
    }
}

export function merchZoneLoading(state = initialState.merchZoneLoading, action) {
    switch (action.type) {
        case types.MERCHZONE_ERROR:
            return false;
        case types.MERCHZONE_LOADING:
            return true;
        case types.MERCHZONE_SUCCESS:
            return false;
        default:
            return state;
    }
}

export function merchZoneError(state = initialState.merchZoneError, action) {
    switch (action.type) {
        case types.MERCHZONE_ERROR:
            return true;
        case types.MERCHZONE_LOADING:
            return false;
        case types.MERCHZONE_SUCCESS:
            return false;
        default:
            return state;
    }
}